import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, OnInit, HostListener
} from '@angular/core';


@Component({
    selector: 'share-type-info',
	templateUrl: './share-type-info.component.html',
	styleUrls: ['./share-type-info.component.scss']
})
export class ShareTypeInfoComponent {

	constructor() {
		return;
	}

}